// maze.co script

const mazeScript = () => `
!function(e,a,t,s){var i,n;try{n=e.sessionStorage.getItem("maze-us")}catch(m){}if(!n){n=new Date().getTime();try{e.sessionStorage.setItem("maze-us",n)}catch(r){}}(i=a.createElement("script")).src=t+"?t="+n+"&apiKey="+s,i.async=!0,a.getElementsByTagName("head")[0].appendChild(i),e.mazeUniversalSnippetApiKey=s}(window,document,"https://snippet.maze.co/maze-universal-loader.js","f244a943-3d57-415b-9a81-87fb45598f60");
`;
export { mazeScript };
